import { Refresh, SwitchLeft } from '@mui/icons-material';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ContentCut from '@mui/icons-material/ContentCut';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PostAddIcon from '@mui/icons-material/PostAdd';
// import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from '@mui/icons-material/Search';
// import PlaylistAddCheckCircleRoundedIcon from "@mui/icons-material/PlaylistAddCheckCircleRounded";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    // ButtonBase,
    Grid,
    ListItemText,
    Menu,
    MenuItem,
    MenuList,
    Paper,
    Tooltip,
} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import { alpha,styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// import ProjectCard from "./ProjectCard";
// import {
//     fetchLastTrackedMissions,
//     // fetchMissions,
//     fetchTrackedMissions,
//     fetchUntrackedMissions,
// } from '../../Api/suiviMission/missions';
import { fetchLastProjects, fetchProjects } from '../../Api/suiviMission/projects';
import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';
import useGetRequest from '../../hooks/useGetRequest';
import MissionSearchInput from './inputs/MissionSearchInput';
import LastProject from './LastProject';
import MissionsList from './MissionsList';
// import MissionCard from "./MissionCard";
import AddProjectModal from './modals/AddProjectModal';
import SwitchMissionModal from './modals/SwitchMissionModal';
import SwitchMissionList from './SwitchMissionsList';
import TrackedMission from './TrackedMission';
import TrcMission from './TrcMission';

function TabPanel(props) {
    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

function getCurrentDate() {
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    var opt_weekday = { weekday: 'long' };
    var today = new Date();
    var weekday = toTitleCase(today.toLocaleDateString('fr-FR', opt_weekday));

    function toTitleCase(str) {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    return weekday + ', ' + today.toLocaleDateString('fr-FR', options);
}

export default function AccueilSuiviMission() {
    //***** Suivi Mission Part
    // const refFocus = useRef();

    // const [anchorElSwitchMission, setAnchorElSwitchMission] = React.useState(null);

    // const openMissionMenu = Boolean(anchorElSwitchMission);
    const { mission
        // , setMission
    } = useGlobalContext();
    const [openSwitchModal, setopenSwitchModal] = useState(false);
    const handleCloseSwitch = () => {
        setopenSwitchModal(false);
    };

    // const handleClick = (event) => {
    //     setAnchorElSwitchMission(event.currentTarget);
    // };
    // const handleClose = () => {
    //     setAnchorElSwitchMission(null);
    // };

    //*****
    React.useEffect(() => {
        console.log({pchito: mission});
    },[mission]);

    const [value, setValue] = React.useState(0);
    // const [missions, setmissions] = React.useState([]);
    // const [trackedmissions, settrackedmissions] = React.useState([]);
    // const [untrackedMissions, setuntrackedMissions] = React.useState([]);
    // const [lastTrackedMissions, setLastTrackedMissions] = React.useState([]);
    const [lastProjects, setLastProjects] = React.useState([]);
    const [newMission, setnewMission] = React.useState(false);
    const [projects, setprojects] = useState([]);
    const { i18n } = useTranslation();
    const {data: trackedmissions , refresh: refreshTrackedMissions} = useGetRequest({url: '/mission/getMissions?tracked=true'});
    const {data: untrackedMissions } = useGetRequest({url: '/mission/getMissions?tracked=false'});
    const {data: lastTrackedMissions } = useGetRequest({url: '/mission/getMissions?number=7'});
    React.useEffect(() => {
    //apiCalls
        // fetchTrackedMissions(settrackedmissions);
        // fetchUntrackedMissions(setuntrackedMissions);
        // fetchLastTrackedMissions(setLastTrackedMissions, 7);
        // ?
        fetchLastProjects(setLastProjects);
        fetchProjects(setprojects);
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handlePlusIconClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePlusIconClose = () => {
        setAnchorEl(null);
    };

    const [openProjectModal, setOpenProjectModal] = React.useState(false);

    const handleCloseProjectModal = () => {
        setOpenProjectModal(false);
        setAnchorEl(null);
    };

    React.useEffect(() => {
        if (!mission?.id) console.log('No Mission on the context, TODO: add navigate /missions here');
        console.log('Mission State', mission, trackedmissions);
    }, [mission]);
    React.useEffect(() => {
        console.log('Mission tracked', trackedmissions);
    }, [trackedmissions]);

    // const handleCardClick = (cardMission) => {
    //   //set mission
    //   setMission(cardMission);
    //   console.log(mission);
    // };
    const openCloseAddMission = () => {
        setnewMission(!newMission);
    };
    return (
        <Box
            sx={{ flexGrow: 1,
                position: 'relative',
                top: '110px', //* comment this top if you want this navBar to replace the other (older)
                zIndex: '10'
            }}
        >
            <AppBar
                position="static"
                color="inherit"
                elevation={0}
            >
                <Toolbar>
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Grid
                            item
                            xs={1}
                        >
                            {/* //!!!!!!!!!!!!!!!!!!!!!!!! */}
                            {/* //* switch the tracked Mission : was inside the navBar */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    height: '42px',
                                    width: 'auto',
                                    backgroundColor: 'transparent',
                                    margin: '25px 14px 14px',
                                    padding: '12px 0px',
                                    alignItems: 'flex-end',
                                }}
                            >
                                <IconButton
                                    id="basic-button"
                                    // aria-controls={openMissionMenu ? 'basic-menu' : undefined}
                                    // aria-expanded={openMissionMenu ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={() => {
                                        setopenSwitchModal(true);
                                    }}
                                >
                                    {/* <KeyboardArrowDown sx={{ color: 'lightgrey' }} /> */}
                                    <SwitchLeft  />
                                </IconButton>
                                <SwitchMissionModal
                                    open={openSwitchModal}
                                    handleClose={handleCloseSwitch}
                                />
                                {/* <Menu
                                    id="basic-menu"
                                    anchorEl={anchorElSwitchMission}
                                    open={openMissionMenu}
                                    onClose={handleClose}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                >
                                    <MenuItem
                                        onClick={() => {
                                            setopenSwitchModal(true);
                                        }}
                                    >
                                        Changer de mission
                                    </MenuItem>
                                </Menu> */}
                            </Box>
                            {/* <Typography
                                variant="h6"
                                noWrap
                                component="div"
                                sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
                            >
                                Accueil
                            </Typography> */}
                        </Grid>
                        <Grid
                            item
                            xs={6}
                        >
                            {/* <Tabs
                value={value}
                onChange={handleChange}
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="secondary tabs example"
              >
                <Tab value="1" label="Item One" />
                <Tab value="2" label="Item Two" />
                <Tab value="3" label="Item Three" />
              </Tabs>
              <TabPanel value="1">Item One</TabPanel>
              <TabPanel value="2">Item Two</TabPanel>
              <TabPanel value="3">Item Three</TabPanel> */}
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="basic tabs example"
                                >
                                    <Tab
                                        label={i18n.t('Accueil')}
                                        {...a11yProps(0)}
                                    />
                                    <Tab
                                        label={i18n.t('Missions Suivies')}
                                        {...a11yProps(1)}
                                    />
                                    <Tab
                                        label={i18n.t('Projets')}
                                        {...a11yProps(2)}
                                    />
                                </Tabs>
                            </Box>
                        </Grid>
                        <Grid
                            item
                            xs={4}
                        >
                            <Search>
                                <SearchIconWrapper>
                                    <SearchIcon />
                                </SearchIconWrapper>
                                <StyledInputBase
                                    placeholder={i18n.t('Search…')}
                                    inputProps={{ 'aria-label': 'search' }}
                                />
                            </Search>
                        </Grid>
                        <Grid
                            item
                            xs={1}
                        >
                            <IconButton
                                aria-label="Add"
                                id="add-button"
                                aria-controls={open ? 'plus-icon-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handlePlusIconClick}
                            >
                                <AddCircleIcon sx={{ color: '#19223F', fontSize: 35 }} />
                            </IconButton>
                            <Menu
                                sx={{ width: 320, maxWidth: '100%' }}
                                id="plus-icon-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handlePlusIconClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuList>
                                    <MenuItem
                                        onClick={() => {
                                            setOpenProjectModal(true);
                                        }}
                                    >
                                        <PostAddIcon>
                                            <ContentCut fontSize="small" />
                                        </PostAddIcon>
                                        <ListItemText className="ms-3">{i18n.t('Projet')}</ListItemText>
                                    </MenuItem>

                                    {/* <MenuItem>
                    <PlaylistAddCheckCircleRoundedIcon>
                      <ContentCut fontSize="small" />
                    </PlaylistAddCheckCircleRoundedIcon>
                    <ListItemText className="ms-3">Mission</ListItemText>
                  </MenuItem> */}
                                </MenuList>
                            </Menu>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>

            <TabPanel
                value={value}
                index={0}
            >
                <Grid
                    container
                    direction={'column'}
                    rowSpacing={8}
                    sx={{ borderRadius: '3px', margin: '0' }}
                >
                    <Grid container>
                        <Grid
                            item
                            xs={12}
                        >
                            <Typography
                                className="text-muted fw-bold text-center mb-0 p-3"
                                fontSize={12}
                            >
                                {getCurrentDate()}
                            </Typography>
                            <Typography
                                variant="h1"
                                noWrap={true}
                                gutterBottom
                                sx={{
                                    display: { xs: 'none', sm: 'initial' },
                                    fontSize: '17px',
                                    fontWeight: 700,
                                    color: 'lightgrey',
                                    width: '154px',
                                    marginLeft: open ? '0px' : '20px',
                                    paddingBottom: '3px',
                                }}
                            >
                                {i18n.t('Mission')} : {mission?.intituleMission}
                            </Typography>
                            {/* <Typography
                                variant="h4"
                                className="fw-bold pb-5 text-center"
                            >
                Bonjour user
                            </Typography> */}
                        </Grid>

                        <Grid
                            item
                            xs={6}
                        >
                            <Paper
                                sx={{
                                    // maxHeight: "400px",

                                    // backgroundColor:"#E9ECF1",
                                    borderColor: '#F0F0F0',
                                    border: '1px solid ',
                                    margin: '20px',
                                    padding: '5px',
                                    overflow: 'auto',
                                    borderRadius: '16px',
                                    maxHeight: '600px',
                                }}
                            >
                                {/* title */}

                                <Typography
                                    variant={'h6'}
                                    sx={{ padding: '3px' }}
                                    align="center"
                                >
                                    {' '}
                                    {i18n.t('Mes missions suivies')}
                                </Typography>

                                {/* body */}

                                {/* searchInput */}
                                {/* addMission */}
                                <Box
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        padding: '5px 18px',
                                        marginBottom: '4px',
                                    }}
                                >
                                    <Grid
                                        container
                                        justifyContent="end"
                                        alignItems="center"
                                    >
                                        {/* <Typography className="fw-bold">
                              Nouvelle mission
                            </Typography> */}
                                        <Tooltip title="Nouvelle mission">
                                            <IconButton
                                                aria-label="delete"
                                                size="large"
                                                onClick={() => {
                                                    openCloseAddMission();
                                                }}
                                            >
                                                <AddBoxOutlinedIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Box>
                                {newMission ? (
                                    <MissionSearchInput
                                        untrackedMissions={untrackedMissions}
                                        openCloseAddMission={openCloseAddMission}
                                    />
                                ) : null}
                                {/* display missions */}
                                {Array.isArray(lastTrackedMissions) && lastTrackedMissions?.map((trackedmission, index) => (
                                    <TrackedMission
                                        key={index}
                                        trackedmission={trackedmission}
                                    />
                                ))}
                                {/* show all */}
                                <Box
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        padding: '5px 18px',
                                        marginBottom: '4px',
                                    }}
                                >
                                    <Typography
                                        className="text-muted"
                                        align="center"
                                    >
                                        <Button
                                            onClick={() => {
                                                setValue(1);
                                            }}
                                        >
                                            {i18n.t('Tout Afficher')}
                                        </Button>
                                    </Typography>
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid
                            item
                            xs={6}
                        >
                            <Paper
                                sx={{
                                    borderColor: '#F0F0F0',
                                    border: '1px solid ',
                                    margin: '20px',
                                    padding: '5px',
                                    overflow: 'auto',
                                    borderRadius: '16px',
                                    maxHeight: '600px',
                                }}
                            >
                                {/* title */}
                                <Box>
                                    <Typography
                                        variant={'h6'}
                                        sx={{ padding: '3px' }}
                                        align="center"
                                    >
                                        {i18n.t('Mes Projets')}
                                    </Typography>
                                </Box>
                                {/* body */}
                                <Box>
                                    {/* searchInput */}
                                    {/* addMission */}
                                    <Box
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            padding: '5px 18px',
                                            marginBottom: '4px',
                                        }}
                                    >
                                        <Grid
                                            container
                                            justifyContent="end"
                                            alignItems="center"
                                        >
                                            {/* <Typography className="fw-bold">
                              Nouvelle mission
                            </Typography> */}
                                            <Tooltip title="Nouveau projet">
                                                <IconButton
                                                    aria-label="delete"
                                                    size="large"
                                                    onClick={() => {
                                                        setOpenProjectModal(true);
                                                    }}
                                                >
                                                    <AddBoxOutlinedIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                    </Box>
                                    {/* display projects */}
                                    {Array.isArray(lastProjects) && lastProjects?.map((lastProject, index) => (
                                        <LastProject
                                            key={index}
                                            lastProject={lastProject}
                                        />
                                    ))}
                                    {/* show all */}
                                    <Box
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            padding: '5px 18px',
                                            marginBottom: '4px',
                                        }}
                                    >
                                        <Typography
                                            className="text-muted"
                                            align="center"
                                        >
                                            <Button
                                                onClick={() => {
                                                    setValue(2);
                                                }}
                                            >
                                                {i18n.t('Tout Afficher')}
                                            </Button>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                    ></Grid>
                </Grid>
            </TabPanel>
            <TabPanel
                value={value}
                index={1}
            >
                {/* <Grid container rowSpacing={2} columnSpacing={4}>
            {trackedmissions?.map((cardMission) => (
              <Grid item lg={4} md={6} xs={12}>
                <MissionCard
                  cardMission={cardMission}
                  key={cardMission.id}
                  onClick={() => {
                    handleCardClick(cardMission);
                  }}
                />
              </Grid>
            ))}

          </Grid> */}
                <Paper sx={{ padding: '30px', height: '100vh' }}>
                    <Typography
                        fontSize={20}
                        style={{ fontWeight: 'bolder', color: '#4A90E2' }}
                    >
                        {i18n.t('Toutes les missions suivie')} :
                    </Typography>
                    <IconButton
                        id="basic-button"
                        onClick={() => {
                            refreshTrackedMissions();
                        }}
                    >
                        <Refresh  />
                    </IconButton>
                    <MissionsList
                        trackedmissions={trackedmissions}
                        refreshTrackedMissions={refreshTrackedMissions}
                    />
                </Paper>
            </TabPanel>
            <TabPanel
                value={value}
                index={2}
            >
                <Grid
                    container
                    rowSpacing={4}
                >
                    <Grid
                        item
                        xs={12}
                    >
                        <Button
                            size="small"
                            variant="contained"
                            sx={{
                                borderRadius: '20px',
                                marginRight: '7px',
                                backgroundColor: '#FFFFFF',
                                color: '#1976D2',
                            }}
                        >
                            {i18n.t('Cette semaine')}
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            sx={{
                                borderRadius: '20px',
                                backgroundColor: '#FFFFFF',
                                color: '#1976D2',
                            }}
                        >
                            {i18n.t('Ce mois')}
                        </Button>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sx={{ marginBottom: '15px' }}
                    >
                        <Typography
                            fontSize={12}
                            style={{ fontWeight: 'bolder', color: '#4A90E2' }}
                        >
                            {i18n.t('Nous avions trouvé')} {projects.length} {i18n.t('projets')} !
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    container
                    spacing={1}
                >
                    {Array.isArray(projects) && projects?.map((project, index) => (
                        <Grid
                            key={index}
                            item
                            xs={12}
                            spacing={1}
                        >
                            {/* <ProjectCard project={project} /> */}
                            <TrcMission project={project} />
                            <Accordion
                                elevation={0}
                                sx={{ marginBottom: '5px' }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography fontSize={11}>{i18n.t('Voir les missions')} - {project.missionId.length} {i18n.t('missions')}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {project.missionId.length > 0 ? (
                                        <SwitchMissionList rows={project.missionId} />
                                    ) : (
                                        <Typography
                                            fontSize={11}
                                            sx={{ color: '#75BD43' }}
                                        >
                                            {i18n.t('Aucune mission dans ce projet')}
                                        </Typography>
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    ))}
                </Grid>
            </TabPanel>

            <AddProjectModal
                open={openProjectModal}
                handleClose={handleCloseProjectModal}
            />
        </Box>
    );
}

